export default __webpack_public_path__ + "static/media/call.1d011c6d.svg";